import React, { FunctionComponent } from 'react';
import { Box } from '@material-ui/core';
import LabelAndPrice from '../labels/LabelAndPrice';
import IndicativeNumber from '../../../../../../common/components/indicativeNumber/IndicativeNumber';
import useScrollToSection from '../../../../../react/navigation/useScrollToSection';
import vehicleTotalPriceStyles from './vehicleTotalPriceStyles';
import Translation from '../../../../../../common/components/translation/Translation';

export interface IVehicleTotalProps {
  price: number;
  currency: string;
  loading?: boolean;
  isComplexModel?: boolean;
}

const VehicleTotalPrice: FunctionComponent<IVehicleTotalProps> = ({ currency, price, loading, isComplexModel }) => {
  const { scrollToDisclaimer } = useScrollToSection();

  const styles = vehicleTotalPriceStyles();

  return (
    <LabelAndPrice
      loading={loading}
      label={
        <Box data-test="customise:summary:vehicle_total_price" component="span">
          <Translation
            id={
              isComplexModel
                ? 'spc.customise.prices.label.vehicleTotalPriceComplex'
                : 'spc.customise.prices.label.vehicleTotalPrice'
            }
          />
          <IndicativeNumber
            dataTest="vehicle_total_price"
            className={styles.boldLabel}
            displayNumber={<Translation id="spc.customise.indicative.vehicleTotalPrice" />}
            onClick={scrollToDisclaimer}
          />
        </Box>
      }
      price={price}
      boldLabel={true}
      priceType="vehicle_total_price"
      currency={currency}
      priceClassNames={styles.priceColor}
    />
  );
};

export default VehicleTotalPrice;
